import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { MEASURE_SOLUTIONS_QUERY_KEY } from './useMeasureSolutions';

export const useDeleteMeasureSolution = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await apiClient.measureSolutions.deleteMeasureSolution.mutation({ params: { id } });
      if (result.status !== 204) {
        throw result.body;
      }
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEASURE_SOLUTIONS_QUERY_KEY] });
      toast.success('Measure solution deleted successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to delete measure solution');
    },
  });
};
